import React, { ReactNode, useMemo } from 'react';

import { EmptyListComponentBase, EmptyListComponentVariant } from '@pflegia/ui/shared/job-board/EmptyListBase.component';

import femalePointingRightWithBubble from '@public/assets/female-pointing-right-with-bubble.png';
import malePointingDown from '@public/assets/male-pointing-down.png';
import malePointingTopLeftWithBubble from '@public/assets/male-pointing-top-left-with-bubble.png';
import maleThinkingWithBubble from '@public/assets/male-thinking-with-bubble.png';

export const EmptyListComponent: React.FC<{
  variant: EmptyListComponentVariant;
  hasJobDetective?: boolean;
  children?: ReactNode;
}> = ({ variant = 'noFilters', children, hasJobDetective = false }) => {
  const smallScreenHeight = hasJobDetective ? 'h-[210px]' : 'h-[456px]';
  const smallScreenImage = useMemo(() => {
    if (variant === 'noResultsSuggestionsModal') return maleThinkingWithBubble;
    return hasJobDetective ? malePointingDown : malePointingTopLeftWithBubble;
  }, [hasJobDetective, variant]);

  const largeScreenImage = useMemo(() => {
    if (variant === 'noResultsSuggestionsModal') return maleThinkingWithBubble;
    return hasJobDetective ? femalePointingRightWithBubble : malePointingTopLeftWithBubble;
  }, [hasJobDetective, variant]);
  return (
    <EmptyListComponentBase
      variant={variant}
      smallScreenImage={smallScreenImage}
      smallScreenImageClassName={smallScreenHeight}
      largeScreenImage={largeScreenImage}>
      {children}
    </EmptyListComponentBase>
  );
};

export default EmptyListComponent;
